const API_URL = process.env.NEXT_PUBLIC_API_URL || 'https://api-viakonnect.ngrok.io';

const API_URL_MOCK = 'http://localhost:3005';

const NEXT_URL = process.env.NEXT_PUBLIC_FRONTEND_URL || 'http://localhost:3006';

const PER_PAGE = 5;

export { API_URL, API_URL_MOCK, NEXT_URL, PER_PAGE };
